import React from "react";

import "./PrintTemplate.css";
import PrintTemplateS11 from "./PrintTemplateS11";

interface Props{
    toningData:any;
}
export class PrintTemplateS11Printer extends React.PureComponent<Props> {
  render() {
    return (
      <PrintTemplateS11 toningData={this.props.toningData} />
    );
  }
}
